<template lang="pug">
app-main-content-layout(title='')
  .c-invites-page
    //- Header Section
    section.c-invites-page__header
      .c-invites-page__header-content
        h1.c-invites-page__heading Invitations
        p.c-invites-page__subtitle Manage pending invitations for users and organizations
      .c-invites-page__header-actions
        el-button.c-invites-page__action-btn(
          type="primary"
          @click="dialog = true; serverError = false"
        )
          fai(type="fal" icon="plus-circle")
          span Invite Organization
        el-button.c-invites-page__action-btn(
          type="primary"
          @click="dialoguser = true; serverError = false"
        )
          fai(type="fal" icon="plus-circle")
          span Invite User

    //- Table Section
    section.c-invites-table-section
      CmsListToolbar(
        v-model="filter"
        search-placeholder="Search invitations by name or email..."
        :sort-value="sortBy"
        :sort-options="sortOptions"
        @search="handleSearch"
        @update:sortValue="sortBy = $event"
        @sort="sortTable"
      )

      //- Skeleton Loader
      template(v-if="loading")
        .c-skeleton-loader
          .c-skeleton-row(v-for="n in 10" :key="n")
            .c-skeleton-cell.c-skeleton-cell--name
            .c-skeleton-cell.c-skeleton-cell--email
            .c-skeleton-cell.c-skeleton-cell--type
      
      //- Table
      el-table(
        v-else
        :data="pagedTableData"
        @row-click="toInviteDetail($event)"
        style="width: 100%"
      ).clickable-rows
        el-table-column(width="15")
        el-table-column(label="Name" min-width="200")
          template(#default="scope")
            .lh-sm
              .font-black {{ scope.row.name }}
        
        el-table-column(label="Email" min-width="200")
          template(#default="scope")
            .lh-sm
              .font-medium {{ scope.row.email }}

        el-table-column(label="Type" min-width="120")
          template(#default="scope")
            span.crm-badge.crm-badge--purple(v-if="scope.row.entity === 'User'") User
            span.crm-badge.crm-badge--teal(v-else) Organization
      
      //- Pagination
      .c-invites-pagination(v-if="filtered.length > 0")
        .c-invites-pagination__controls
          el-button.c-invites-pagination__button(
            @click="setPage(page - 1)"
            :disabled="page === 1 || loading"
          ) Prev
          .c-invites-pagination__info
            span.c-invites-pagination__page-number Page {{ page }}
            span.c-invites-pagination__item-count(v-if="pagedTableData.length > 0") Showing {{ startItem }}-{{ endItem }} of {{ filtered.length }}
          el-button.c-invites-pagination__button(
            @click="setPage(page + 1)"
            :disabled="!hasMorePages || loading"
          ) Next

  dialog-add-invite(
    v-if="dialog"
    v-model="dialog"
    :sending-invite="sendingInvite"
    @save-item="organizationInvite"
    :server-error="serverError"
    @close-dialog="dialog=false"
  )

  dialog-add-user-invite(
    v-if="dialoguser"
    v-model="dialoguser"
    :sending-invite="sendingInvite"
    @save-item="userInvite"
    :server-error="serverError"
    @close-dialog="dialoguser=false"
  )
</template>

<script>
import {
  defineComponent, ref,
  onMounted, reactive,
  computed,
} from 'vue';
import shared from './shared';
import DialogAddInvite from './DialogAddInvite.vue';
import DialogAddUserInvite from './DialogAddUserInvite.vue';
import CmsListToolbar from '@/components/CmsListToolbar.vue';

export default defineComponent({
  name: 'Invites',
  components: { DialogAddInvite, DialogAddUserInvite, CmsListToolbar },
  setup() {
    // let nextToken;
    const {
      route,
      router,
      loading,
      doGetInvites,
      doCreateInvite,
      doCreateUserInvite,
    } = shared();
    const filter = ref('');
    const items = reactive({ items: [] });
    const serverError = ref('');
    const sendingInvite = ref(false);
    const dialog = ref(false);
    const dialoguser = ref(false);
    const sortOptions = [{ label: 'Name', value: 'name' }, { label: 'Email', value: 'email' }];
    const sortBy = ref('');

    function sortTable() {
      if (sortBy.value.value === 'name') {
        items.items.sort((a, b) => a.name.localeCompare(b.name));
      } else if (sortBy.value.value === 'email') {
        items.items.sort((a, b) => a.email.localeCompare(b.email));
      }
    }

    const filtered = computed(() => {
      if (filter.value === '') {
        return items.items;
      }
      const regex = new RegExp(`${filter.value}`, 'gi');
      return items.items.filter((x) => {
        if (x.name) {
          return x.name.match(regex);
        }
        return false;
      });
    });

    async function findInvites() {
      try {
        loading.value = true;
        items.items = await doGetInvites();
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
        // console.log('finally');
      }
    }

    onMounted(async () => {
      await findInvites();
    });

    function toInviteDetail(itm) {
      if (route.path === '/manage/invites') router.push(`invites/${itm.id}/info`);
    }

    async function organizationInvite(item) {
      try {
        loading.value = true;
        sendingInvite.value = true;
        await doCreateInvite(item);
        dialog.value = false;
        await findInvites();
      } catch (err) {
        serverError.value = err.message;
      } finally {
        loading.value = false;
        sendingInvite.value = false;
      }
    }

    async function userInvite(item) {
      try {
        loading.value = true;
        sendingInvite.value = true;
        await doCreateUserInvite(item);
        dialoguser.value = false;
        await findInvites();
      } catch (err) {
        serverError.value = err.message;
      } finally {
        loading.value = false;
        sendingInvite.value = false;
      }
    }
    //________create function for pagination datatable________
    const page = ref(1);
    const pageSize = 10;

    const pagedTableData = computed(() => {
      const start = (page.value - 1) * pageSize;
      const end = start + pageSize;
      if (filter.value !== '') {
        return filtered.value.slice(start, end);
      }

      return items.items.slice(start, end);
    });

    const startItem = computed(() => {
      const start = (page.value - 1) * pageSize;
      return start + 1;
    });

    const endItem = computed(() => {
      const start = (page.value - 1) * pageSize;
      return Math.min(start + pageSize, filtered.value.length);
    });

    const hasMorePages = computed(() => {
      const totalPages = Math.ceil(filtered.value.length / pageSize);
      return page.value < totalPages;
    });

    const setPage = (newPage) => {
      if (newPage < 1) return;
      const totalPages = Math.ceil(filtered.value.length / pageSize);
      if (newPage > totalPages) return;
      page.value = newPage;
    };

    const handleSearch = () => {
      page.value = 1; // Reset to first page on search
    };
    return {
      // data (static)
      loading,
      filter,
      page,
      pageSize,
      pagedTableData,
      startItem,
      endItem,
      hasMorePages,
      // data (reactive)
      items,
      serverError,
      input: ref(),
      dialog,
      dialoguser,
      sendingInvite,
      filtered,
      sortOptions,
      sortBy,
      // methods
      toInviteDetail,
      organizationInvite,
      setPage,
      userInvite,
      sortTable,
      handleSearch,
    };
  },
});
</script>

<style lang="scss" scoped>
@import './crm-list';

.c-invites-page {
  @include crm-page;

  &__header-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
}

@include crm-header('c-invites-page');
@include crm-table('c-invites-table-section');
@include crm-cells;
@include crm-skeleton;

.c-skeleton-cell--type {
  width: 100px;
}

.font-black {
  font-weight: 500;
  color: $foreground;
}

.font-medium {
  color: $gray-600;
}

// Pagination - prev/next
.c-invites-pagination {
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-top: 1px solid $border;

  &__controls {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    min-width: 180px;
  }

  &__page-number {
    font-size: 0.875rem;
    font-weight: 500;
    color: $foreground;
  }

  &__item-count {
    font-size: 0.75rem;
    color: $gray-600;
  }
}

@media (max-width: 768px) {
  .c-invites-page {
    padding: 1.5rem;

    &__header-actions {
      width: 100%;
    }
  }

  .c-invites-pagination__controls {
    gap: 0.75rem;
  }
}

@media (max-width: 480px) {
  .c-invites-page {
    padding: 1rem;
  }
}
</style>
